import React from 'react';
const benefits = ['Qué es la glicación y los AGEs — explicado sin tecnicismos, con analogías', 'El Método del Orden del Plato — mismo plato, diferente orden, diferentes resultados', 'Más de 40 nombres ocultos del azúcar en etiquetas de supermercados de EE.UU.', 'Cómo leer etiquetas y detectar azúcar en segundos', 'Plan de acción post-comida — qué hacer cuando te sales del plan', 'Checklist diario de 14 días con registro visual', 'Señales tempranas que muchas personas pasan por alto', 'Lista de alimentos que generan confusión — productos que parecen saludables pero contienen azúcar escondida'];
export function ContentMap() {
  return <section className="py-20 md:py-28 px-4 bg-dark-primary" id="bonuses" data-id="element-170">
      <div className="max-w-content mx-auto" data-id="element-171">
        <div className="text-center mb-16" data-id="element-172">
          <span className="inline-block font-mono text-[11px] text-gold uppercase tracking-[0.2em] mb-4" data-id="element-173">
            QUÉ HAY DENTRO
          </span>
          <h2 className="font-serif text-3xl md:text-4xl text-cream leading-tight max-w-2xl mx-auto" data-id="element-174">
            Lo que obtendrás dentro de El Azúcar Silencioso
          </h2>
        </div>

        <div className="flex flex-col md:flex-row gap-12 items-center md:items-start mb-16" data-id="element-175">
          {/* LEFT: Book Mockup */}
          <div className="w-full md:w-[40%] flex justify-center" data-id="element-176">
            <div className="relative w-[200px] md:w-[240px]" style={{
            transform: 'rotateY(-15deg) rotateX(5deg)',
            transformStyle: 'preserve-3d',
            perspective: '1000px'
          }} data-id="element-177">
              <div className="absolute top-0 left-0 bottom-0 w-4 bg-gradient-to-r from-[#0a0a0a] to-[#1a1a1a] rounded-l-sm" style={{
              transform: 'translateZ(-2px) translateX(-2px)'
            }} data-id="element-178"></div>
              <img src="https://cdn.magicpatterns.com/uploads/x4XZTN8gQQCc5QtzEW7QdL/Portada_Ebook_Principal.png" alt="El Azúcar Silencioso" className="w-full h-auto rounded-sm relative z-10" style={{
              boxShadow: '20px 20px 40px -10px rgba(0,0,0,0.8), 0 0 0 1px rgba(201,168,76,0.1)'
            }} data-id="element-179" />
            </div>
          </div>

          {/* RIGHT: Benefits List */}
          <div className="w-full md:w-[60%]" data-id="element-180">
            <ul className="space-y-4" data-id="element-181">
              {benefits.map((benefit, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-182">
                  <span className="text-gold shrink-0 mt-1" data-id="element-183">
                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-184">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-185" />
                    </svg>
                  </span>
                  <span className="font-sans text-cream text-[16px] leading-relaxed" data-id="element-186">
                    {benefit}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Feature Badges */}
        <div className="flex flex-wrap justify-center gap-4 md:gap-8 border-t border-border-subtle pt-10" data-id="element-187">
          <div className="bg-dark-card border border-border-subtle px-4 py-2 rounded-full flex items-center gap-2" data-id="element-188">
            <span data-id="element-189">📚</span>
            <span className="font-mono text-[11px] text-cream uppercase tracking-widest" data-id="element-190">
              Ebook PDF
            </span>
          </div>
          <div className="bg-dark-card border border-border-subtle px-4 py-2 rounded-full flex items-center gap-2" data-id="element-191">
            <span data-id="element-192">⏱️</span>
            <span className="font-mono text-[11px] text-cream uppercase tracking-widest" data-id="element-193">
              Lectura: ~1 hora
            </span>
          </div>
          <div className="bg-dark-card border border-border-subtle px-4 py-2 rounded-full flex items-center gap-2" data-id="element-194">
            <span data-id="element-195">🌎</span>
            <span className="font-mono text-[11px] text-cream uppercase tracking-widest" data-id="element-196">
              En español
            </span>
          </div>
        </div>
      </div>
    </section>;
}